import { style } from 'typestyle'
import { important } from 'csx'
export const hidei = style({ display: important('none') })
